import React from 'react'
import { Typography, withStyles } from '@material-ui/core'
import styles from '../styles'

import UserType from 'src/model/user-types'
import { hasInAppAuthAccess } from '../../utils/in-app-auth-access'

const Badge = props => {
  const { type, classes } = props

  const premiumControl = () => {
    const userControl = UserType[window.CONSTANTS.USER_ROLE_ID]

    // Type 1: "Plus" badge for Basic/Starter users (features every paid plan has)
    if (
      (userControl == 'Basic' ||
        userControl == 'Starter' ||
        userControl == 'StarterStarter - Legacy' ||
        userControl == 'Starter - A') &&
      type == 1
    ) {
      return {
        text: 'Plus',
        textColor: '#015FFB',
        backgroundColor: '#015ffb14',
      }
    }
    // Type 2: "Pro" badge for users without Pro-equivalent plans (invitation-only access starts at Pro)
    if (
      !(
        userControl == 'Premium Plus' ||
        userControl == 'Premium Plus v2' ||
        userControl == 'Premium - A' ||
        userControl == 'AppSumo (Tier 3)' ||
        userControl == 'AppSumo (Tier 3A)' ||
        userControl == 'AppSumo (Tier 4)' ||
        userControl == 'AppSumo (Tier 5)' ||
        userControl == 'Elite' ||
        userControl == 'AppSumo (Tier 6)' ||
        userControl == 'AppSumo (Tier 7)' ||
        userControl == 'AppSumo (Tier 8)' ||
        userControl == 'AppSumo (Tier 9)' ||
        userControl == 'Pro' ||
        // Invitation-only access starts at Pro v2, so Plus still sees the upsell.
        userControl == 'Pro v2' ||
        userControl == 'Launch' ||
        userControl == 'Essentials' ||
        userControl == 'Growth' ||
        userControl == 'Scale' ||
        userControl == 'Enterprise' ||
        UserType.isTrialEquivalent(userControl)
      ) &&
      type == 2
    ) {
      return {
        text: 'Pro',
        textColor: '#015FFB',
        backgroundColor: '#015ffb14',
      }
    }
    // Type 3: "Pro" badge for SCORM export, which starts at Pro v2.
    if (type == 3 && !UserType.hasScormExport(userControl)) {
      return {
        text: 'Pro',
        textColor: '#015FFB',
        backgroundColor: '#015ffb14',
      }
    }
    // Type 4: "Plus" badge for Basic users (features that any paid plan has)
    if (
      !(
        userControl == 'Premium Plus' ||
        userControl == 'Premium Plus v2' ||
        userControl == 'Premium - A' ||
        userControl == 'Premium' ||
        userControl == 'Premium v2' ||
        userControl == 'AppSumo (Tier 2)' ||
        userControl == 'AppSumo (Tier 2A)' ||
        userControl == 'AppSumo (Tier 3)' ||
        userControl == 'AppSumo (Tier 3A)' ||
        userControl == 'AppSumo (Tier 4)' ||
        userControl == 'AppSumo (Tier 5)' ||
        userControl == 'Elite' ||
        userControl == 'AppSumo (Tier 6)' ||
        userControl == 'AppSumo (Tier 7)' ||
        userControl == 'AppSumo (Tier 8)' ||
        userControl == 'AppSumo (Tier 9)' ||
        userControl == 'Pro' ||
        userControl == 'Plus' ||
        userControl == 'Pro v2' ||
        userControl == 'Launch' ||
        userControl == 'Essentials' ||
        userControl == 'Growth' ||
        userControl == 'Scale' ||
        userControl == 'Enterprise' ||
        UserType.isTrialEquivalent(userControl)
      ) &&
      type == 4
    ) {
      return {
        text: 'Plus',
        textColor: '#015FFB',
        backgroundColor: '#015ffb14',
      }
    }
    if (type == 5) {
      return {
        text: 'Soon',
        textColor: '#637381',
        backgroundColor: '#919eab14',
      }
    }
    // Type 7: "Headless" badge for features of the Headless plans (In-app authentication)
    if (type == 7 && !hasInAppAuthAccess(userControl)) {
      return {
        text: 'Headless',
        textColor: '#212B36',
        backgroundColor: '#919eab14',
      }
    }
    // Type 6: "Plus" badge for features the current plans have, but old Pro doesn't
    // (Accessibility Widget, Certificate Templates, Community Boards, AI Voice Over)
    // Note: Plus is listed here because it has Accessibility, Community Boards and
    // AI Voice Over. It does NOT have Certificate Templates — that one gate lives in
    // UserType.hasCertifications, which excludes Plus separately.
    if (
      type == 6 &&
      !(
        userControl == 'Elite' ||
        userControl == 'Plus' ||
        userControl == 'Pro v2' ||
        userControl == 'Launch' ||
        userControl == 'Essentials' ||
        userControl == 'Growth' ||
        userControl == 'Scale' ||
        userControl == 'Enterprise' ||
        UserType.isTrialEquivalent(userControl) ||
        userControl == 'AppSumo (Tier 5)' ||
        userControl == 'AppSumo (Tier 6)' ||
        userControl == 'AppSumo (Tier 7)' ||
        userControl == 'AppSumo (Tier 8)' ||
        userControl == 'AppSumo (Tier 9)'
      )
    ) {
      return {
        text: 'Plus',
        textColor: '#015FFB',
        backgroundColor: '#015ffb14',
      }
    }
    // Type 8: "Plus" badge for Collaboration settings navigation. Shares its rule
    // with the settings page so the badge can't promise a different plan.
    if (type == 8 && !UserType.hasCollaboration(window.CONSTANTS.USER_ROLE_ID)) {
      return {
        text: 'Plus',
        textColor: '#015FFB',
        backgroundColor: '#015ffb14',
      }
    }
  }
  const viewContents = premiumControl()

  return viewContents ? (
    <div
      className={classes.badge}
      style={{
        backgroundColor: viewContents.backgroundColor,
      }}
    >
      <Typography
        fontSize={'11px'}
        fontWeight={500}
        style={{ color: viewContents.textColor }}
      >
        {viewContents.text}
      </Typography>
    </div>
  ) : null
}

export default withStyles(styles)(Badge)
